<div class="customizer prevent-scroll" [@fadeInOutTransition]>

  @if(isReady) {
    <div class="ximage">

      <div class="realtime-and-copyright">
        <realtime-wrapper
          #realtime
          [ngClass]="{'full': !userPreferencesStore.configurationStringActive()}"
          [modelGroup]="modelGroup"
          [model]="model"
          [modelSize]="chosenModelSize"
          [variants]="chosenVariants.Variants"
          [engraving]="currentEngraving"
          [isPrecious]="brandModeService.isPrecious"
          [currentMainComponent]="currentMainComponent"
          [currentSubComponent]="currentSubComponent"
        ></realtime-wrapper>

        <div class="summary-and-copyright">
          <copyright></copyright>

          @if (userPreferencesStore.configurationStringActive()) {
            <div class="summary">
              <customizer-summary
                [model]="model"
                [modelGroup]="modelGroup"
                [modelSize]="chosenModelSize"
                [variants]="summaryModels"
                [configuration]="(modelGroup?.IsConfigurationBased || modelGroup?.IsBothConfigAndVariantBased) ? $safeNavigationMigration(baseConfiguration?.ColorNameAndCode) : null"
                [menu]="components"
                [isDemo]="isDemo"
                [compactMode]="'default'"
                [templeInclination]="chosenTempleInclination"
              ></customizer-summary>
            </div>
          }
        </div>
      </div>

      @if (brandModeService.isPrecious && isLimited) {
        <div class="limited-edition-stock-note">
          {{ 'LIMITED.REALTIME-NOTE' | translate }}
        </div>
      }

      <availability-text
        [variantOrModelIsNew]="!model?.Discontinued"
        [modelgroup]="modelGroup"
        [date]="$safeNavigationMigration(model?.Discontinued)"
        [new]="$safeNavigationMigration(model?.New)"
        [useNewDetails]="false"
      ></availability-text>

      <div class="breadcrumb-and-favorites">
        <breadcrumb></breadcrumb>

        <app-favorites-area class="favorite-button"
          [variants]="chosenVariants.Variants"
          [variantString]="variantString"
          [model]="model"
          [configuration]="baseConfiguration"
          [modelSize]="chosenModelSize"
          [isInCollection]="isInCollection"
          [favoriteUuid]="favoriteUuid"
          [templeInclination]="chosenTempleInclination"
          (applyFavoriteCollectionChangeEmitter)="applyFavoriteCollectionChange($event)"
        ></app-favorites-area>
      </div>

      <app-get-price
        class="price-customiser"
        (getPriceEmitter)="getPrice()"
        [priceResponse]="priceResponse"
      ></app-get-price>

      @if (isUserInAdminMode || showAddToInspirationButton()) {
        <div class='administration-wrapper '>
          <div class="administration">

            @if (showAddToInspirationButton()) {
              <add-to-inspiration
                [variants]="chosenVariants.Variants"
                [model]="model"
                [configuration]="baseConfiguration"
                [modelSize]="chosenModelSize"
                [customizerInspirationState]="currentInspirationCustomizationstate"
                [templeInclination]="chosenTempleInclination"
                (AddedToInspirationClicked)="addedToInspiration()"
              ></add-to-inspiration>
            }

            @if (isUserInAdminMode) {
              <set-default-button
                [variants]="chosenVariants.Variants"
                [originalVariants]="allVariants"
                [model]="model"
                [configuration]="baseConfiguration"
                [modelSize]="chosenModelSize"
                (updateOriginalVariants)="setOriginalVariants($event)"
              ></set-default-button>
            }

          </div>
        </div>
      }

    </div>

    <div class="xmenu" [ngClass]="{'expanded': menuService.subMenuIsExpanded}">

      @if (errors.length) {
        <div class="customizer-errors" [ngClass]="{'highlightChangesOverlay': showHighlightChangesOverlay}">
          <customizer-changes [changes]="errors" (changesChange)="saveChangesTempleLengthCheck($event)"></customizer-changes>
        </div>
      }

      <customizer-loader
        [ngClass]="{'expanded': menuService.subMenuIsExpanded}"
        [age]="age"
        [comment]="currentComment"
        [component]="currentSubComponent || currentMainComponent"
        [configuration]="baseConfiguration"
        [configurations]="allConfigurations"
        [discountErrors]="discountErrors"
        [discount]="discount"
        [engraving]="currentEngraving"
        [firstPair]="firstPair"
        [gender]="gender"
        [hasFixtures]="hasFixtures"
        [hasForms]="hasForms"
        [imageOnlyVariants]="imageOnlyVariants"
        [isLimited]="isLimited"
        [modelGroup]="modelGroup"
        [modelSize]="chosenModelSize"
        [model]="model"
        [reference]="currentReference"
        [selectedCase]="chosenCase"
        [selectedTempleInclination]="chosenTempleInclination"
        [state]="currentCustomizationState"
        [variants]="chosenVariants.Variants"
        (matchColors)="matchColors($event)"
        (setImageSliderByName)="setCurrentImageByName($event)"
        (updateAge)="updateAge($event)"
        (updateCase)="updateCase($event)"
        (updateClipOnOnly)="updateClipOnOnly($event)"
        (updateCollapsedOnComponent)="updateCollapsedOnMainComponent($event)"
        (updateComment)="updateComment($event)"
        (updateComponentSize)="updateComponentSize($event)"
        (updateConfiguration)="updateConfiguration($event)"
        (updateCurrentMainComponent)="updateCurrentMainComponent($event)"
        (updateDiscount)="updateDiscount($event)"
        (updateEngraving)="updateEngraving($event)"
        (updateFirstPair)="updateFirstPair($event)"
        (updateGender)="updateGender($event)"
        (updateHasFixtures)="updateHasFixtures($event)"
        (updateHasForms)="updateHasForms($event)"
        (updateMenuVisited)="updateMenuVisited($event)"
        (updateModel)="updateModel($event)"
        (updateParts)="updateParts($event)"
        (updateReference)="updateReference($event)"
        (updateSize)="updateModelSize($event)"
        (updateTempleInclination)="updateTempleInclination($event)"
        (updateVariant)="updateVariant($event)"
        (updateVariantDesign)="updateVariantDesign($event)"
        (updateVariants)="updateVariants($event)"
      ></customizer-loader>

      <cstmsr-summary-sidebar [variants]="summaryModels" [modelCode]="$safeNavigationMigration(model?.Code)" [modelSize]="$safeNavigationMigration(chosenModelSize?.Code)" [templeInclination]="chosenTempleInclination" [ngClass]="{'show': showSummary}"></cstmsr-summary-sidebar>

      <div class="menu-bar">
        <div class="menu-wrapper">
          <customizer-menu [blocked]="errors.length > 0" [chosenCase]="chosenCase" [chosenVariants]="chosenVariants.Variants" [components]="components" [configurations]="allConfigurations" [currentMainComponent]="currentMainComponent" [currentSubComponent]="currentSubComponent" [modelGroup]="modelGroup" [modelSize]="chosenModelSize" [model]="model" (currentComponentChange)="updateCurrentComponent($event)" (currentMainComponentChange)="updateCurrentMainComponent($event)"></customizer-menu>
        </div>

        <div class="buttons" [ngClass]="{'extra-padding':parts}">
          <add-to-bag-button class="customizer-add-button" [disabled]="!discountErrors.isValid" [added]="currentCustomizationState !== customizerStateEnum.NEWORDER" [parts]="parts ? parts.length : 0" (addToBagChange)="AddToBag()"></add-to-bag-button>

          <div class="config">
            <button (click)="toggleConfiguration()">
              @if (!showSummary) {
                <i class="fa-light fa-list-check"></i>
              }
              @if (showSummary) {
                <i class="fa-light fa-xmark"></i>
              }
              {{ 'CUSTOMISER.CONFIGURATION' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  @if (showSunMessage) {
    <cstmsr-sun-lense-info (close)="hideSunDetails()"></cstmsr-sun-lense-info>
  }

</div>
